// define getter functions for harmony exports
__w_pdfjs_require__.d = (exports, definition) => {
	for(var key in definition) {
		if(__w_pdfjs_require__.o(definition, key) && !__w_pdfjs_require__.o(exports, key)) {
			Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
		}
	}
};


// WEBPACK FOOTER //
// webpack://pdfjs-dist/build/pdf.worker/webpack/runtime/define property getters